import React from 'react';
import Header from './Header'
import Skills from './Skills'
import Contact from './Contact'
import About from './About'
import Home from './Home'
import Footer from './Footer'
import {BrowserRouter,Routes,Route} from 'react-router-dom';

const App = () => {
  return (

    <>
   <BrowserRouter>
 <Header/>
    <Routes>
      <Route path='/' element={ <Home/>}/>
      <Route path='/contact' element={ <Contact/>}/>
      <Route path='/about' element={ <About/>}/>
      <Route path='/skills' element={ <Skills/>}/>
    </Routes>
    <Footer/>
   </BrowserRouter>
    </>
  )
}

export default App